import { VCS_INTEGRATION_USED_BY_COLUMN_ID } from "../constants";
import IntegrationsVcsUsedByTableDropdownCell from "./DropdownCell";
import IntegrationsVcsUsedByTableNameCell from "./NameCell";
import IntegrationsVcsUsedByTableSpaceCell from "./SpaceCell";
import IntegrationsVcsUsedByTableTypeCell from "./TypeCell";

const VCS_INTEGRATION_USED_BY_TABLE_CELLS = {
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.TYPE]: IntegrationsVcsUsedByTableTypeCell,
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.NAME]: IntegrationsVcsUsedByTableNameCell,
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.SPACE]: IntegrationsVcsUsedByTableSpaceCell,
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN]: IntegrationsVcsUsedByTableDropdownCell,
};

export default VCS_INTEGRATION_USED_BY_TABLE_CELLS;
